/**
 * Calculate the length in a desired unit of measurement from meters
 *
 * * Imperial    - ft
 * * US Imperial - ft (US)
 * * Metric      - m
 *
 * @param meters
 * @param units
 * @param round
 * @returns
 */
export function lengthToString(meters, units, round = 2) {
    const ft = 3.28084;
    const usFt = 3937 / 1200;
    switch (units) {
        case 'imperial':
            return `${(meters * ft).toFixed(round)} ft`;
        case 'us imperial':
            return `${(meters * usFt).toFixed(round)} ft (US)`;
        case 'metric':
            return `${meters.toFixed(round)} m`;
    }
}
/**
 * Calculate the area in a desired unit of measurement from square meters
 *
 * * Imperial    - sq. ft
 * * US Imperial - sq. ft (US)
 * * Metric      - sq. m
 *
 * @param sqMeters
 * @param units
 * @param round
 * @returns
 */
export function areaToString(sqMeters, units, round = 2) {
    const ft = 3.28084;
    const usFt = 3937 / 1200;
    switch (units) {
        case 'imperial':
            return `${(sqMeters * (ft * ft)).toFixed(round)} sq. ft`;
        case 'us imperial':
            return `${(sqMeters * (usFt * usFt)).toFixed(round)} sq. ft (US)`;
        case 'metric':
            return `${sqMeters.toFixed(round)} sq. m`;
    }
}
